/**
 * Links into the handbook (ADR 0021), served by every installation under /docs: English at the root, German and
 * Spanish under /docs/de/ and /docs/es/. A page is the handbook path with a trailing slash ("guides/planner/").
 */
const LOCALES = new Set(["de", "es"]);

export function helpUrl(page = "", lang = "en"): string {
  const l = lang.slice(0, 2).toLowerCase();
  return `/docs/${LOCALES.has(l) ? `${l}/` : ""}${page}`;
}

/** The handbook page for a section of Settings (by its id); the general settings page when there is none. */
const SETTINGS: Record<string, string> = {
  "settings-access": "admin/access-and-api/",
  "settings-assistant": "admin/assistant-models/",
  "settings-automations": "admin/automations/",
  "settings-backup-email": "admin/backup-and-restore/",
  "settings-buttons": "integrations/buttons/",
  "settings-calendars": "guides/planner/",
  "settings-capture": "integrations/phone/",
  "settings-circle": "household/household-mode/",
  "settings-device": "household/devices/",
  "settings-feed": "integrations/calendar-feed/",
  "settings-import": "integrations/importing/",
  "settings-integrations": "integrations/forgejo-and-vscode/",
  "settings-mail": "integrations/email-in/",
  "settings-my-profile": "household/people/",
  "settings-notify": "integrations/notifications/",
  "settings-people": "household/people/",
  "settings-plugins": "admin/plugins/",
  "settings-secrets": "admin/configuration/",
  "settings-signals": "guides/signals-and-places/",
};

export function settingsHelp(sectionId: string): string {
  return SETTINGS[sectionId] ?? "guides/settings/";
}
